<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.permits.statuses.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddStatusDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.permits.statuses.statuses_dialog.title_new') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/permitManagement/statuses"
          list-relative-path="statuses"
          list-item-component-name="PermitStatusListItem"
          list-item-prop-name="status"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/permitManagement/statuses"
        filter-relative-path="filters"
      />
    </div>

    <AddPermitStatusDialog
      :is-open="isAddStatusDialogOpen"
      @close="isAddStatusDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { statusesTableColumns } from '@/components/Administration/PermitManagement/Statuses/constants';
import AddPermitStatusDialog from '@/components/Administration/PermitManagement/Statuses/AddPermitStatusDialog.vue';
import { mapState } from 'vuex';

export default {
  name: 'PermitStatusesV2',
  components: {
    AddPermitStatusDialog,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddStatusDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.permitManagement.statuses.filters,
      isLoading: (state) => state.v2.admin.cms.permitManagement.statuses.isLoading,
    }),
    columns() {
      return statusesTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();

    this.$store.dispatch('v2/admin/cms/permitManagement/actionDates/loadAllActionDates');
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/permitManagement/statuses/load');
    },
  },
};
</script>
